import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      d: "M8.5 20.75a2.5 2.5 0 0 1-5 0v-4.5a2.5 2.5 0 0 1 5 0v4.5Zm20 0a2.5 2.5 0 0 1-5 0v-4.5a2.5 2.5 0 0 1 5 0v4.5Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      d: "M3.5 16.25v-2.5c0-6.904 5.596-12.5 12.5-12.5s12.5 5.596 12.5 12.5v2.5m0 4.5v2.5a5 5 0 0 1-5 5h-5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "2",
      d: "M16 30.75a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "goftino"}) } }